/**

 **/
define(function (require) {
    "use strict";

    var $ = require("jquery");
    var _ = require("underscore");
    var Backbone = require("backbone");
    var Marionette = require("marionette");
    var Translator = require("i18n/translator");
    var template = require('ui.plugins/gridView/filter/filter-types/templates/timeFrameFilter.tmpl');
    var Logger = require('logger');
    var DateUtility = require("utils/DateUtility");
    var TimeFrame = require("ui/timeframe/Timeframe");

    var DEFAULT_MAX_DAYS = 31;


    var TimeFrameFilter = Marionette.ItemView.extend({
        className: "timeFrame-filter-container",
        template: template,
        ui: {
            timeFrameContainer: ".filter-input-container"
        },
        uiComponents: {
            timeFrameComponent: {
                type: TimeFrame,
                options: "_getTimeFrameOptions"
            }
        },

        initialize: function(options) {
            this.logger = Logger.getLogger("TimeFrameFilter");
            this.selectedValues = options.selectedValues;
            this.filterData = options.filterData || {};
            this.componentOptions = this.filterData.componentOptions || {};
        },

        _getTimeFrameOptions: function() {
            var selectedTimeFrame = !_.isEmpty(this.selectedValues) ? this.selectedValues : this.filterData.selectedValues;
            var maxDays = this.componentOptions.maxDaysForTimeframeValue || DEFAULT_MAX_DAYS;
            var maxDaysLabel = this.componentOptions.maxDaysForTimeframeLabel || Translator.translate({key: "LEUIComponents.gridView.filter.timeframe.maxDaysLabel", args: [maxDays]});

            var defaultOptions = {
                container: "view.ui.timeFrameContainer",
                isEndDateCheckboxHidden: true,
                isLimitEndDatePicker: false,
                isLimitStartDatePicker: false,
                showButtons: false,
                isLimitFutureDates: true,
                maxDaysForTimeframeValue: maxDays,
                selectedTimeFrame: selectedTimeFrame,
                maxDaysForTimeframeLabel: maxDaysLabel
            };

            var mergedOptions = $.extend({}, defaultOptions, this.componentOptions);
            return mergedOptions;
        },

        getFilterSelection: function() {
            return this.uiComponents.timeFrameComponent.getSelectedTimeframe();
        },

        resetCollectionFilter: function() {
            return {};
        }
    });

    return TimeFrameFilter;
});
